/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [
	{
		_id: "fortnite1",
		title: "This Game is so Hard and I'm Too Bad at it - Live Insaan Fortnite",
		vidSrc: "87K8VPAhxrg",
		creator: "Live Insaan",
		creatorImg:
			"https://yt3.ggpht.com/ytc/AKedOLQfwzuW-nGu7N-oL6r1gIwK8_48Khf-vFqLnzHJHQ=s176-c-k-c0x00ffffff-no-rj",
	},
	{
		_id: "fortnite2",
		title: "Fortnite Gameplay (PC HD) [1080p60FPS]",
		vidSrc: "5Vzxj6flcfM",
		creator: "Thorneful",
		creatorImg:
			"https://yt3.ggpht.com/ytc/AKedOLRFpJvq-wBohC02mHXTpx_uhRit3eV204GWWoiHbg=s176-c-k-c0x00ffffff-no-rj",
	},
	{
		_id: "fortnite3",
		title:
			"40 Elimination Solo vs Squad Win Gameplay Full Game Season 8 (Fortnite PC Controller)",
		vidSrc: "cSXJcHTFM94",
		creator: "SENSEI",
		creatorImg:
			"https://yt3.ggpht.com/SY00DAt6IftAdIaSCPCNgD-jvqrscFmNrek4Zv8ZDx3J52WaMUQhskM7rZJH3rzFVosO4dVdQA=s176-c-k-c0x00ffffff-no-rj",
	},
	{
		_id: "fortnite4",
		title: "Fortnite World Cup Solo Finals - Full Match (Bugha)",
		vidSrc: "EXuqhgghPuA",
		creator: "IGN",
		creatorImg:
			"https://yt3.ggpht.com/H_---ano_f27DOCejDhUdBMtBcxcv32MoXmFKQc_mBcxYSH4HPZTGuBUdm7UgI5VlutMOVX2=s176-c-k-c0x00ffffff-no-rj",
	},
	{
		_id: "fortnite5",
		title: "36 KILLS SOLO vs. SQUADS Personal Record (Fortnite Battle Royale)",
		vidSrc: "AJEiUsYYofE",
		creator: "Tfue",
		creatorImg:
			"https://yt3.ggpht.com/ytc/AKedOLSfq9ESLRuuwnjlnOMtbhq92eozwF_5YuG_Gxo=s176-c-k-c0x00ffffff-no-rj",
	},
	{
		_id: "lol1",
		title: "The COMPLETE Beginner's Guide - How to Play League of Legends!",
		vidSrc: "u9JdENUoGik",
		creator: "Skill Capped Challenger LoL Guides",
		creatorImg:
			"https://yt3.ggpht.com/ytc/AKedOLTIrGbCXTTfY1JdX44Ss1ayJL0zmeqvqLysMa00=s176-c-k-c0x00ffffff-no-rj",
	},
	{
		_id: "lol2",
		title: "TOP 50 SMARTEST LEAGUE OF LEGENDS PLAYS OF 2020!",
		vidSrc: "AFOgshG8-sk",
		creator: "Protatomonster",
		creatorImg:
			"https://yt3.ggpht.com/ytc/AKedOLQDWpAvt9iUvfbQww7eAGtTSfjBVgydtdOO4osb=s176-c-k-c0x00ffffff-no-rj",
	},
	{
		_id: "lol3",
		title:
			"FNC vs IG | Finals Game 1 | World Championship | Fnatic vs Invictus Gaming (2018)",
		vidSrc: "xZLFVV2qxQQ",
		creator: "LoL Esports",
		creatorImg:
			"https://yt3.ggpht.com/LXB_CL1rmmyDxw8HhIsLwFvXlhcoeb03gzWyEMRSO-3plf2llPYv6XTNJpyFXnvDBKss_bB8ZQ=s88-c-k-c0x00ffffff-no-rj",
	},
	{
		_id: "lol4",
		title:
			"FNC vs IG | Finals Game 2 | World Championship | Fnatic vs Invictus Gaming (2018)",
		vidSrc: "-7ON55o3uJA",
		creator: "LoL Esports",
		creatorImg:
			"https://yt3.ggpht.com/LXB_CL1rmmyDxw8HhIsLwFvXlhcoeb03gzWyEMRSO-3plf2llPYv6XTNJpyFXnvDBKss_bB8ZQ=s88-c-k-c0x00ffffff-no-rj",
	},
	{
		_id: "lol5",
		title:
			"FNC vs IG | Finals Game 3 | World Championship | Fnatic vs Invictus Gaming (2018)",
		vidSrc: "7XexqRIbtLU",
		creator: "LoL Esports",
		creatorImg:
			"https://yt3.ggpht.com/LXB_CL1rmmyDxw8HhIsLwFvXlhcoeb03gzWyEMRSO-3plf2llPYv6XTNJpyFXnvDBKss_bB8ZQ=s88-c-k-c0x00ffffff-no-rj",
	},
	{
		_id: "csgo1",
		title:
			"Counter-Strike: Global Offensive (2021) - Gameplay (PC UHD) [4K60FPS]",
		vidSrc: "KnpljMWwy3o",
		creator: "Throneful",
		creatorImg:
			"https://yt3.ggpht.com/ytc/AKedOLRFpJvq-wBohC02mHXTpx_uhRit3eV204GWWoiHbg=s176-c-k-c0x00ffffff-no-rj",
	},
	{
		_id: "csgo2",
		title: "Best 400IQ BIGBRAIN PLAYS of 2021",
		vidSrc: "beFrZ0Eq4AY",
		creator: "CSGOpoetry",
		creatorImg:
			"https://yt3.ggpht.com/ytc/AKedOLTm--ISxiRymmIjoxi1HIi0wET_OHCNdLrD2uVj=s176-c-k-c0x00ffffff-no-rj",
	},
	{
		_id: "csgo3",
		title:
			"Counter-Strike: Global Offensive (2019) - Gameplay (PC HD) [1080p60FPS]",
		vidSrc: "rOpariPFAeM",
		creator: "Throneful",
		creatorImg:
			"https://yt3.ggpht.com/ytc/AKedOLRFpJvq-wBohC02mHXTpx_uhRit3eV204GWWoiHbg=s176-c-k-c0x00ffffff-no-rj",
	},
	{
		_id: "csgo4",
		title:
			"CS:GO - Fnatic vs. EnVyUS [Dust2] - ESL One Cologne 2015 - Grand Final Map 1",
		vidSrc: "02I5vVxlJhU",
		creator: "ESL Archives",
		creatorImg:
			"https://yt3.ggpht.com/ytc/AKedOLTIb6UC6cwAZU8OZRTACPvRMy2id0E1Wm0gYFJRzg=s176-c-k-c0x00ffffff-no-rj",
	},
	{
		_id: "csgo5",
		title:
			"CS:GO - Fnatic vs. EnVyUS [Cbble] - ESL One Cologne 2015 - Grand Final Map 2",
		vidSrc: "_Ef6cXH1oC8",
		creator: "ESL Archives",
		creatorImg:
			"https://yt3.ggpht.com/ytc/AKedOLTIb6UC6cwAZU8OZRTACPvRMy2id0E1Wm0gYFJRzg=s176-c-k-c0x00ffffff-no-rj",
	},
	{
		_id: "minecraft1",
		title: "TIME TO MAKE MY WORLD | MINECRAFT GAMEPLAY #1",
		vidSrc: "3lvKnDxRivA",
		creator: "Techno Gamerz",
		creatorImg:
			"https://yt3.ggpht.com/ytc/AKedOLSoJmn-BUZ8UGQcNGoNk1Dkmg5j4e4RiueszLFJdg=s176-c-k-c0x00ffffff-no-rj",
	},
	{
		_id: "minecraft2",
		title: "I Survived 100 DAYS as an ENDERMAN in HARDCORE Minecraft!",
		vidSrc: "941QEI5v1iE",
		creator: "MaxCraft",
		creatorImg:
			"https://yt3.ggpht.com/spVQrqnY6GVjIAHdRNTjyc2xV6MB6-4t6N84L-0zjdygypFNGQ8X0PlSiA95mcnEX5X7mcpTTgU=s176-c-k-c0x00ffffff-no-rj",
	},
	{
		_id: "minecraft3",
		title: "I Survived 100 DAYS as HEROBRINE in HARDCORE Minecraft!",
		vidSrc: "DK_DL2EkGyE",
		creator: "Bronzo",
		creatorImg:
			"https://yt3.ggpht.com/jwMFItUvbR5dIKoZYIiCp30Amih7XtiZZWkZjuHP4FYSIjKLXsdf0Ie__xRI7rw8p9j88DtgJ5E=s176-c-k-c0x00ffffff-no-rj",
	},
	{
		_id: "minecraft4",
		title: "I Survived 100 DAYS as a STRIDER in HARDCORE Minecraft!",
		vidSrc: "SCG61X0OAPg",
		creator: "MaxCraft",
		creatorImg:
			"https://yt3.ggpht.com/spVQrqnY6GVjIAHdRNTjyc2xV6MB6-4t6N84L-0zjdygypFNGQ8X0PlSiA95mcnEX5X7mcpTTgU=s176-c-k-c0x00ffffff-no-rj",
	},
	{
		_id: "minecraft5",
		title: "I made 10,000 villagers worship me",
		vidSrc: "10RCGDZYk8U",
		creator: "Grox",
		creatorImg:
			"https://yt3.ggpht.com/ytc/AKedOLTHIQiEJHysqTgcfhyR6ra8ckRLLpZSvCIiTYA_Zg=s176-c-k-c0x00ffffff-no-rj",
	},
	{
		_id: "valorant1",
		title: "VALORANT Gameplay (PC HD) [1080p60FPS]",
		vidSrc: "Wrdh5HrOCMc",
		creator: "Throneful",
		creatorImg:
			"https://yt3.ggpht.com/ytc/AKedOLRFpJvq-wBohC02mHXTpx_uhRit3eV204GWWoiHbg=s176-c-k-c0x00ffffff-no-rj",
	},
	{
		_id: "valorant2",
		title: "A Complete Beginner's Guide To Valorant",
		vidSrc: "umWJCOh_oE4",
		creator: "ProGuides Valorant Tips, Tricks and Guides",
		creatorImg:
			"https://yt3.ggpht.com/0gJv1A9JqvjqqD9s5OS9TeRDmFuTRTFHXyp3X99bRM0fYJIkCiRtRY8DBellFFSHmw9oAII4zEY=s176-c-k-c0x00ffffff-no-rj",
	},
	{
		_id: "valorant3",
		title: "VALORANT - ALL AGENT ABILITIES EXPLAINED! Tips and Advice!",
		vidSrc: "weOrw7xiBFM",
		creator: "Stylosa",
		creatorImg:
			"https://yt3.ggpht.com/GSjNw-FQ9oX10v2m7Jd4Ou_8n3y5QXWoJtzzHD4sLEkrB-nXkQIWI8WfuKAHNlgszCdyiUNx=s88-c-k-c0x00ffffff-no-rj",
	},
	{
		_id: "valorant4",
		title: "TenZ vs Kyedae VALORANT 1v1 Rematch!",
		vidSrc: "ZrDTpURsXwA",
		creator: "100 Thieves Esports",
		creatorImg:
			"https://yt3.ggpht.com/ytc/AKedOLSLLZcDtDvDzAJYeq5J2DUX0vO2icChhnqkyDCOpw=s176-c-k-c0x00ffffff-no-rj",
	},
	{
		_id: "valorant5",
		title: "Kyedae & TenZ BEST/CUTE VALORANT MOMENTS - Valorant Montage (uWu)",
		vidSrc: "okGkyf_C9-0",
		creator: "Valorant Flavorz - Gaming Flavorz",
		creatorImg:
			"https://yt3.ggpht.com/ytc/AKedOLQb0S4-z46LX12HsGQeqMh9l_9crtrHaYI8_Zag=s176-c-k-c0x00ffffff-no-rj",
	},
];
